import { useMemo } from "react";
import { useSelector } from "react-redux";
import { FlightSearchSelectors } from "@b2bportal/core-flights";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { PackageSearchSelectors } from "@/store/packages/selectors";

interface RouteInfo {
  origin: string;
  destination: string;
  date: string;
}

export const usePackageFlightDeparturePageHeader = () => {
  const { t } = useI18nContext();

  const departureDate = useSelector(FlightSearchSelectors.getDepartureDate);

  // Grab origin and destination from package context
  const { label: packageOriginLabel } = useSelector(
    PackageSearchSelectors.getSearchFormOrigin
  );
  const { label: packageDestinationLabel } = useSelector(
    PackageSearchSelectors.getSearchFormDestination
  );

  const routeInfo: RouteInfo = useMemo(() => {
    return {
      origin: packageOriginLabel,
      destination: packageDestinationLabel,
      date: dayjs(departureDate).format("MMM D"),
    };
  }, [packageOriginLabel, packageDestinationLabel, departureDate]);

  return {
    title: t("core-packages.flights.departureTitle"),
    routeInfo,
  };
};
